import type { FC } from "react";

import { cn } from "@aurem/ui";
import auremLogo from "./assets/images/aurem.svg";
import { usePlatformConfig } from "./use-platform-config";

type AuthiconProps = {
  className?: string;
};
export const AuthIcon: FC<AuthiconProps> = ({ className }) => {
  const theme = usePlatformConfig();

  if (theme.logoUrlRegular) {
    return (
      <img
        className="me-auto h-12 w-auto object-contain"
        src={theme.logoUrlRegular}
      />
    );
  }

  return <img src={auremLogo} alt="logo" className={cn("h-7", className)} />;
};
